import Vue from 'vue'
import VeeValidate from 'vee-validate'

const config = {
  locale: 'zh',
  events: 'input',
  dictionary: {
    zh: {
      messages: {
        required: (field) => field + ' 必填',
        min: (field, args) => field + ' 最少 ' + args + ' 個字',
        max: (field, args) => field + ' 不得超過 ' + args + ' 個字',
        digits: (field, args) => field + ' 請輸入 ' + args + ' 位數字',
        min_value: (field, args) => field + ' 不得低於 ' + args,
        max_value: (field, args) => field + ' 不得超過 ' + args,
        integer: (field) => field + ' 必須為整數',
        mimes: (field, args) => field + ' 必須符合MIME類型 ' + args,
        ext: (field, args) => field + ' 必須符合檔案類型 ' + args,
        dimensions: (field, args) => field + ' 寬與高須分別為 ' + args,
        regex: (field) => '格式有誤 ' + field,
        email: (field) => field + ' 請輸入正確Email格式',
        confirmed: () => '密碼不相符',
        youtubeLink: (field) => field + ' 不是youtube內嵌影片連結格式'
      },
      attributes: {
        account: '帳號',
        password: '密碼'
      }
    }
  }
}

Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/plugins/validation.js